import type { AgentTraceKind, AgentTraceProvider } from "@shared/lib/admin-db";

export const AGENT_TRACE_PROVIDER_LABELS: Record<AgentTraceProvider, string> = {
  deepseek: "DeepSeek",
  openai: "OpenAI",
  bedrock: "Amazon Bedrock",
  perplexity: "Perplexity",
  exa: "Exa",
  jina: "Jina Reader",
  fetch: "Récupération directe",
};

export const AGENT_TRACE_KIND_LABELS: Record<AgentTraceKind, string> = {
  analysis: "Analyse (agent de recherche)",
  enrichment_org: "Enrichissement — organisation",
  enrichment_contact: "Enrichissement — interlocuteur",
  enrichment_person_search: "Recherche web — personne",
  enrichment_person_synthesis: "Synthèse — personne",
  enrichment_osint_search: "Recherche OSINT — organisation",
  enrichment_osint_synthesis: "Synthèse OSINT — organisation",
  lead_email: "E-mail d’approche — rédaction",
  prospect_email: "E-mail de prospection — rédaction",
  prospect_review: "E-mail de prospection — garde-fou",
  prospect_reply: "Prospection — classement d’une réponse",
  source_search: "Recherche — canaux de données",
  source_read: "Lecture — page publique",
};
